module.exports = __webpack_public_path__ + "img/Primordial-3.7a0bc4bd.png";